import { computed, defineComponent, useCssModule } from '@nuxtjs/composition-api';
export default defineComponent({
    name: 'BoxImage',
    props: {
        box: {
            required: true,
            type: Object,
        },
    },
    setup(props) {
        /**
         * CSS Modules.
         */
        const css = useCssModule();
        const caption = computed(() => {
            let { alt = null, caption = null } = props.box.data;
            if (typeof alt !== 'string') {
                alt = '';
            }
            if (typeof caption !== 'string') {
                caption = '';
            }
            if (caption) {
                caption = caption.split(' / ').join('<span>&middot;</span>');
            }
            if (alt && caption) {
                alt = alt + '<span>&middot;</span>';
            }
            return alt + caption;
        });
        const subtitle = computed(() => {
            const { subtitle } = props.box.data || {};
            if (!subtitle?.length) {
                return '';
            }
            return subtitle.replace(/\n/g, '<br>');
        });
        const shouldShowDescription = computed(() => {
            return caption.value || subtitle.value || props.box.data?.title;
        });
        return {
            css,
            caption,
            shouldShowDescription,
            subtitle,
        };
    },
});
